import { Navigate } from 'react-router-dom'
import { RoutesManager } from '../routesManager'

/**
 * This component is used to redirect the user to the home page.
 * It's distinct from <Callback /> because Auth0 does NOT redirect the user to routes it is rendered.
 */
export const RedirectToHomePageBasedOnPermissions = () => <Navigate to={RoutesManager.home.root.getURL()} />
